import styled from 'styled-components';
import { breakpoints } from '../../styles/brand';

/**
 * Acima de tudo que fica fixo no topo: HeaderMobile (5000) e a barra compacta
 * da tela do torneio (4000). Abaixo disso o toast sumia atrás do menu.
 */
export const Container = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  padding: 30px;
  z-index: 6000;

  @media (max-width: ${breakpoints.md}) {
    left: 0;
    padding: calc(0.75rem + env(safe-area-inset-top, 0px))
      max(0.75rem, env(safe-area-inset-right, 0px)) 0
      max(0.75rem, env(safe-area-inset-left, 0px));
    /* Ocupa a largura toda: sem isso, bloquearia os toques no menu. */
    pointer-events: none;

    > div {
      pointer-events: auto;
    }
  }
`;
